module.exports = __webpack_public_path__ + "img/play-button.37ec1dd7.png";